/**
 * The 44px column at the end of a lead row.
 *
 * Was two unlabelled icon buttons plus a `<select>` sitting in the row, which
 * meant three controls competing for the same few pixels and a native popup
 * landing on top of the list. All three are entries in one menu now.
 *
 * The entries themselves live in `LeadRowItems`, because the row's right-click
 * menu offers the same ones and two lists would drift apart.
 */
import { MoreHorizontal } from "lucide-react";
import { cn } from "@wa/ui";
import type { LeadStatus, ScanLead } from "../../../lib/scanLeads";
import { Pop, useClosePops } from "../../shell/Pop";
import type { T } from "../site-scanner/types";
import { LeadRowItems } from "./LeadRowItems";

export function LeadRowMenu({
  lead,
  canManage,
  busy,
  t,
  onOpenScan,
  onOpenBrain,
  onStatus,
  onPushToCrm,
  onDismiss,
}: {
  lead: ScanLead;
  canManage: boolean;
  busy: boolean;
  t: T;
  onOpenScan: () => void;
  onOpenBrain: () => void;
  onStatus: (s: LeadStatus) => void;
  onPushToCrm: () => void;
  onDismiss: () => void;
}) {
  const close = useClosePops();

  return (
    <span className="relative z-[1] justify-self-end">
      <Pop
        trigger={(open) => (
          <button
            type="button"
            className={cn("crm-cb", open && "is-on")}
            title={t("common.more")}
            aria-label={t("common.more")}
            aria-haspopup="menu"
            aria-expanded={open}
            disabled={busy}
          >
            <MoreHorizontal className="size-4" />
          </button>
        )}
      >
        <LeadRowItems
          lead={lead}
          canManage={canManage}
          t={t}
          close={close}
          onOpenScan={onOpenScan}
          onOpenBrain={onOpenBrain}
          onStatus={onStatus}
          onPushToCrm={onPushToCrm}
          onDismiss={onDismiss}
        />
      </Pop>
    </span>
  );
}
